const saveEmail = (email) => {
  localStorage.setItem('userEmail', email);
};
const getEmail = (email) => {
  return localStorage.getItem('userEmail', email);
};

export default { saveEmail, getEmail };
